import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import PetCartNest from "./pages/PetCartNest";
import DogBoarding from "./pages/services/DogBoarding";
import DogWalking from "./pages/services/DogWalking";
import Daycare from "./pages/services/Daycare";
import Recreation from "./pages/services/Recreation";
import Grooming from "./pages/services/Grooming";
import Freshtails from "./pages/Freshtails";
import About from "./pages/About";
import Contact from "./pages/Contact";
import WagAndWine from "./pages/WagAndWine";
import OurStory from "./pages/company/OurStory";
import Careers from "./pages/company/Careers";
import Press from "./pages/company/Press";
import Faqs from "./pages/resources/Faqs";
import News from "./pages/resources/News";
import PetCareTips from "./pages/resources/PetCareTips";
import CommunityEvents from "./pages/resources/CommunityEvents";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import TermsOfService from "./pages/legal/TermsOfService";
import CookiePolicy from "./pages/legal/CookiePolicy";
import RefundPolicy from "./pages/legal/RefundPolicy";
import ScrollToTop from "./components/ScrollToTop";
import CookieConsent from "./components/CookieConsent";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          {/* Demo parent login removed — was misleading for ads / trust scanners */}
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route path="/petcart-nest" element={<PetCartNest />} />
          <Route path="/services/dog-boarding" element={<DogBoarding />} />
          <Route path="/services/dog-walking" element={<DogWalking />} />
          <Route path="/services/daycare" element={<Daycare />} />
          <Route path="/services/recreation" element={<Recreation />} />
          <Route path="/services/grooming" element={<Grooming />} />
          <Route path="/freshtails" element={<Freshtails />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/wag-and-wine" element={<WagAndWine />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/press" element={<Press />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/news" element={<News />} />
          <Route path="/pet-care-tips" element={<PetCareTips />} />
          <Route path="/community-events" element={<CommunityEvents />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/freshtails/products" element={<Landing />} />
          <Route path="/freshtails/popsicles" element={<Landing />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
